export const itgSteps = state => state.itgSteps;
